import {
  BUXUS_APP_DISPLAY_VERSION,
  BUXUS_SITE_CONDENSED_LABEL,
  BUXUS_SITE_URL,
  REGISTRATION_PROFILE_JSON_KEY,
  profileRegistrationRows,
} from '@buxus/shared'
import { useEffect, useMemo, useState } from 'react'
import './ProfileScreen.css'

export function ProfileScreen() {
  const [raw, setRaw] = useState<string | null>(null)

  useEffect(() => {
    try {
      setRaw(localStorage.getItem(REGISTRATION_PROFILE_JSON_KEY))
    } catch {
      setRaw(null)
    }
  }, [])

  const rows = useMemo(() => {
    if (!raw) return []
    try {
      return profileRegistrationRows(JSON.parse(raw) as unknown)
    } catch {
      return []
    }
  }, [raw])

  return (
    <section className="app-profile">
      {!raw ? (
        <p className="app-profile-empty">
          No saved profile details yet. Sign in again to refresh registration data from the API.
        </p>
      ) : rows.length === 0 ? (
        <p className="app-profile-empty">Profile data is present but no recognizable fields were found.</p>
      ) : (
        <dl className="app-profile-dl">
          {rows.map((r) => (
            <div key={r.label} className="app-profile-row">
              <dt>{r.label}</dt>
              <dd>
                {r.values.map((line, i) => (
                  <span key={`${r.label}-${i}`} className="app-profile-value-line">
                    {line}
                  </span>
                ))}
              </dd>
            </div>
          ))}
        </dl>
      )}

      <footer className="app-profile-footer">
        <span>v{BUXUS_APP_DISPLAY_VERSION} - Learn more at </span>
        <a href={BUXUS_SITE_URL} target="_blank" rel="noopener noreferrer">
          {BUXUS_SITE_CONDENSED_LABEL}
        </a>
        <span>.</span>
      </footer>

    </section>
  )
}
